/* global System */

export default {
  WertErmittlerModal: () =>
    System.import(/* webpackChunkName: "WertErmittlerModal" */ './index'),
}
